export default __webpack_public_path__ + "static/media/youtube_landing02.349ce55e.png";